import React, { Component } from "react";
import { toast } from "react-toastify";
import Numeral from "numeral";
import { getDmService } from "../services/Api";
import "numeral/locales/pt-br";

class Budget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subTotal: 0
    };
  }

  async componentWillMount() {
    Numeral.locale("pt-br");
    await this.getSubTotal();
  }

  getSubTotal = async () => {
    try {
      const items = await getDmService("/Pedido/MostraCarrinho");

      if (items.carrinho.length) {
        for (const obj of items.carrinho) {
          if (obj.tipo !== "Agência") {
            this.setState({ subTotal: obj.valorTotal });
          }
        }
      }
    } catch (err) {
      toast.error("Não foi possível atualizar os gastos atuais");
    }
  };

  render() {
    const { subTotal } = this.state;
    const { subTotalCurrent, saldoAtual } = this.props;
    const balanceCurrent = subTotalCurrent
      ? subTotalCurrent + subTotal
      : subTotal;
    const saldo = saldoAtual - balanceCurrent;

    return (
      <div className="bread-info">
        <span className="text">
          <span className="text-light">Meu Budget: </span>
          <strong>{Numeral(saldoAtual + 0).format("$ 0.00")} </strong>
          {balanceCurrent !== 0 && (
            <React.Fragment>
              (-
              {Numeral(balanceCurrent).format("$ 0.00")}
              {")"}
            </React.Fragment>
          )}
        </span>
        <span className="text">
          {balanceCurrent !== 0 && (
            <React.Fragment>
              <span className="text-light">Saldo: </span>
              <strong>{Numeral(saldo).format("$ 0.00")}</strong>
            </React.Fragment>
          )}
        </span>
      </div>
    );
  }
}

export default Budget;



// WEBPACK FOOTER //
// ./src/components/Budget.js